import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { auth } from "../Firebase/FirebaseConfig";
import BeersView from "./BeersView";
import UserNavigation from "../navigation/UserNavigation";
import "../styles/MainContent.css";
import AboutView from "./AboutView";
import SupportPage from "./SupportPage";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsAndConditionsView from "./TermsAndConditionsView";
import ActivityFeedView from "./ActivityFeedView";
import ProfileView from "./ProfileView";
import CellarView from "./CellarView";
import { CellarProvider } from "../contexts/CellarContext";

const MainContent = () => {
  const [selectedTab, setSelectedTab] = useState("about");
  const [currentUser, setCurrentUser] = useState(null); // State to track the logged-in user
  const previousUserRef = useRef(undefined);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
      const wasAuthenticated = Boolean(previousUserRef.current);
      const isAuthenticated = Boolean(user);

      if (
        isAuthenticated &&
        !wasAuthenticated &&
        (location.pathname === "/" || location.pathname === "/about")
      ) {
        navigate("/app/activity", { replace: true });
      } else if (!isAuthenticated && location.pathname.startsWith("/app/")) {
        navigate("/about", { replace: true });
      }

      previousUserRef.current = user;
    });

    // Set the selectedTab based on the current path
    const path = location.pathname;
    if (path === "/" || path === "/about") {
      setSelectedTab("about");
    } else if (path === "/support") {
      setSelectedTab("support");
    } else if (path === "/privacy-policy") {
      setSelectedTab("privacy");
    } else if (path === "/terms") {
      setSelectedTab("terms");
    } else if (path.startsWith("/app/")) {
      const requestedTab = path.replace("/app/", "");
      if (["activity", "beers", "cellar", "profile"].includes(requestedTab)) {
        setSelectedTab(requestedTab);
      }
    }

    return () => unsubscribe();
  }, [location.pathname, navigate]);

  const renderContent = () => {
    switch (selectedTab) {
      case "activity":
        return <ActivityFeedView />;
      case "beers":
        return <BeersView />;
      case "cellar":
        return (
          <CellarProvider>
            <CellarView userSafeEmail={currentUser?.email.replace(/\./g, "-").replace("@", "-")} />
          </CellarProvider>
        );
      case "profile":
        return <ProfileView />;
      case "about":
        return <AboutView />;
      case "support":
        return <SupportPage />;
      case "privacy":
        return <PrivacyPolicy />;
      case "terms":
        return <TermsAndConditionsView />;
      default:
        return null;
    }
  };

  return (
    <div className={currentUser ? "main-content main-content--authenticated" : "main-content"}>
      {currentUser && <UserNavigation />}
      <section className="main-content__view">{renderContent()}</section>
    </div>
  );
};

export default MainContent;
